import React from 'react';
import { TitleSection, TitleSection2 } from './components/Titles';
import { AndroidDownload } from './components/Download';
import { LogoSection } from './components/Logo';

const Card = ({ children }: { children: React.ReactNode }) => (
  <div className="grid place-items-center grid-rows-1 md:grid-rows-1 gap-0 min-h-96 w-full  ">
    <div className="bg-darkGray flex flex-col items-center justify-center h-full w-full rounded-2xl text-white max-w-lg hover:shadow-2xl">
      {children}
    </div>
  </div>
);

const HomePage = () => {
  return (
    <div className="bg-lightGray  w-full">
      <div className="container  items-center my-3 justify-center bg-lightGray h-full w-full gap-12 grid grid-cols-1 xl:grid-cols-2 xl:grid-rows-2">
        <Card>
          <LogoSection />
        </Card>
        <Card>
          <TitleSection />
        </Card>
        <Card>
          <TitleSection2 />
        </Card>
        <Card>
          <AndroidDownload />
        </Card>
      </div>
    </div>
  );
};

export default HomePage;
